import React, { useEffect, useState } from "react";
import CourseInfoTile from "../components/CourseInfoTile";
import SectionSelector from "../components/SectionSelector";
import { IoSend } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import app from "../axiosConfig";
import { addToastMsg } from "../redux/auth/authActions";
import Loader from "../components/Loader";

function CreateMessage() {
  const [message, setMessage] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userId = useSelector((state) => state.auth?.user?.userId);
  const course = useSelector((state) =>
    state.pwaData?.courses.find(
      (course) => course.course_code === params.course_code
    )
  );
  const handleSendMessage = async () => {
    try {
      if (selectedSections.length === 0) {
        dispatch(addToastMsg("Please select at least one section", "error"));
        return;
      }
      if (message === "") {
        dispatch(addToastMsg("Please type a message", "error"));
        return;
      }
      const { data } = await app.post("/pwa/create-message", {
        message_content: message,
        classes: selectedSections,
        course: course._id,
        faculty: userId,
      });
      navigate(`/Messages/${params.course_code}/course-sections`);
      dispatch(addToastMsg(data.message, "success"));
    } catch (error) {
      dispatch(addToastMsg(error.response?.data?.message, "error"));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!course) return <Loader />;

  return (
    <div className="body-container">
      <CourseInfoTile course={course} />
      <SectionSelector
        selectedSections={selectedSections}
        setSelectedSections={setSelectedSections}
      />
      <textarea
        className="message-tile-container create-message-input"
        placeholder="Message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={5}
      />
      <button
        className="send-message-button"
        onClick={() => handleSendMessage()}
      >
        <IoSend />
        <span>Send</span>
      </button>
    </div>
  );
}

export default CreateMessage;
